import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IdentityWebApiClient, UpdateUserDarkModeRequest } from 'identity-webapi-client';
import { filter } from 'rxjs/operators';
import { FetchService } from '.';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  urlViewedAs: string = '';

  constructor(
    private identityWebApiClient: IdentityWebApiClient,
    private authService: AuthService,
    private configService: ConfigService,
    private fetchService: FetchService,
    private router: Router) {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      if (!event.urlAfterRedirects.startsWith('/unauthorized')) {
        this.urlViewedAs = '';
      }
    });
  }

  updateUserDarkMode(darkMode: boolean) {
    var userId = this.authService.getUserId();
    var request = new UpdateUserDarkModeRequest();
    request.id = userId;
    request.darkMode = darkMode;

    this.identityWebApiClient.updateUserDarkMode(request).then(response => {
    }, error => {
    });
  }

  viewAsUser(userId: string) {
    let shouldNavigateBack = !!this.urlViewedAs && this.router.url.startsWith('/unauthorized');

    if (!shouldNavigateBack) {
      this.urlViewedAs = this.router.url;
    }

    return this.authService.manager.createSigninRequest().then((signinRequest) => {
      let url = new URL(signinRequest.url);
      url.searchParams.set("userId", userId);
      url.pathname = "/Account/ViewAs";

      let urlString = url.toString();
      let options_ = {
        method: "GET"
      };

      return this.fetchService.fetch(urlString, options_).then((response) => {
        if (response && response.ok) {
          return response.text().then((responseText) => {
            // sign-out of current user
            this.authService.manager.revokeAccessToken();
            this.authService.manager.removeUser();

            // sign-in with viewAs
            let completeUrl = new URL(this.configService.config.userManagerSettings.redirect_uri);
            completeUrl.search = responseText;
            return this.authService.completeViewAsAuthentication(completeUrl.toString()).then(() => {
              let url = this.router.url;
              if (shouldNavigateBack) {
                url = this.urlViewedAs;
              }
              return this.router.navigateByUrl('/unauthorized', { skipLocationChange: true }).then(() => {
                this.router.navigate([url]);
              });
            });
          });
        }
      });
    });
  }
}
